/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */
import type {
  DictionaryDTO,
  GetAvailableCampaignObjectivesParams,
  GetFolderSubitemNamesPathParameters,
  GetFolderTemplateParams,
  GetFolderTemplatePathParameters,
  GetGroupItemsParams,
  GetGroupItemsPathParameters,
  MondayCampaignTemplateDTO,
  MondayGroupDTO,
} from "../schemas";

import { customInstance } from "../../config/mutator";

export const getMonday = () => {
  /**
 * Get all groups from Monday.com board

Required authority: PERM_CLIENT_READ
 */
  const getBoardGroups = () => {
    return customInstance<MondayGroupDTO[]>({ url: `/api/monday/groups`, method: "GET" });
  };
  /**
 * Get items from a specific Monday.com group with filtering

Required authority: PERM_CLIENT_READ
 */
  const getGroupItems = ({ groupId }: GetGroupItemsPathParameters, params: GetGroupItemsParams) => {
    return customInstance<MondayCampaignTemplateDTO[]>({
      url: `/api/monday/groups/${groupId}/items`,
      method: "GET",
      params,
    });
  };
  /**
 * Get the campaign templates of a folder's Monday production items, merged into one

Required authority: PERM_CLIENT_READ
 */
  const getFolderTemplate = (
    { folderId }: GetFolderTemplatePathParameters,
    params: GetFolderTemplateParams,
  ) => {
    return customInstance<MondayCampaignTemplateDTO>({
      url: `/api/monday/folders/${folderId}/template`,
      method: "GET",
      params,
    });
  };
  /**
 * Get subitem names of a folder's Monday production items to check which touchpoints already exist

Required authority: PERM_CLIENT_READ
 */
  const getFolderSubitemNames = ({ folderId }: GetFolderSubitemNamesPathParameters) => {
    return customInstance<string[]>({
      url: `/api/monday/folders/${folderId}/subitem-names`,
      method: "GET",
    });
  };
  /**
 * Get campaign objectives that have available templates for the given strategy and population type

Required authority: PERM_CLIENT_READ
 */
  const getAvailableCampaignObjectives = (params: GetAvailableCampaignObjectivesParams) => {
    return customInstance<DictionaryDTO[]>({
      url: `/api/monday/campaign-objectives`,
      method: "GET",
      params,
    });
  };
  return {
    getBoardGroups,
    getGroupItems,
    getFolderTemplate,
    getFolderSubitemNames,
    getAvailableCampaignObjectives,
  };
};
export type GetBoardGroupsResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getMonday>["getBoardGroups"]>>
>;
export type GetGroupItemsResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getMonday>["getGroupItems"]>>
>;
export type GetFolderTemplateResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getMonday>["getFolderTemplate"]>>
>;
export type GetFolderSubitemNamesResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getMonday>["getFolderSubitemNames"]>>
>;
export type GetAvailableCampaignObjectivesResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getMonday>["getAvailableCampaignObjectives"]>>
>;
